import { Link, styled, Typography } from '@mui/material';

export const LinkW = styled(Link)`
  margin-right: 8px;
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.palette.primary.p080};

  &:last-of-type {
    margin-right: 0;
  }

  @media (max-width: 1023px) {
    display: block;
    width: 100%;
    margin: 0 0 8px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
`;

export const CardW = styled('div')`
  width: 72px;
  background: ${({ theme }) => theme.palette.white.main};
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 1023px) {
    width: 100%;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
    border-radius: 8px;
  }
`;

export const TitleW = styled(Typography)`
  font-weight: 500;
  font-size: 10px;
  line-height: 16px;
  width: 63px;
  max-width: 63px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  margin-top: 8px;

  @media (max-width: 1023px) {
    flex: 1;
    font-size: 14px;
    line-height: 20px;
    text-align: left;
    width: auto;
    max-width: none;
    margin-top: 0;
  }
`;

export const SubtitleW = styled(Typography)`
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  width: 63px;
  max-width: 63px;
  white-space: nowrap;
  text-align: center;
  color: ${({ theme }) => theme.palette.secondary.light};

  @media (max-width: 1023px) {
    width: auto;
    max-width: none;
    text-align: left;
  }
`;

export const IconW = styled('div')`
  display: flex;
  align-items: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
`;

export const ChevronW = styled('div')`
  display: none;

  @media (max-width: 1023px) {
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.palette.primary.p080};
    flex-shrink: 0;
  }
`;
